import type { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSidebar } from '../../contexts/SidebarContext';
import { Sidebar } from './Sidebar';
import styles from './AppLayout.module.css';

interface AppLayoutProps {
  /** false on the authentication pages: no sidebar and no offset. */
  showSidebar: boolean;
  children: ReactNode;
}

/**
 * Layout of the app: navigation sidebar on the left (signed-in user)
 * and the page content on the right.
 */
export function AppLayout({ showSidebar, children }: AppLayoutProps) {
  const { isAuthenticated } = useAuth();
  const { collapsed } = useSidebar();
  const withSidebar = showSidebar && isAuthenticated;

  return (
    <div
      className={styles.layout}
      data-sidebar={withSidebar ? (collapsed ? 'collapsed' : 'expanded') : 'none'}
    >
      {withSidebar && <Sidebar />}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
